import React, { useState } from 'react';
import { 
  Box,
  Paper,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { HexColorPicker } from 'react-colorful';

function ThemeSettings({ open, onClose, onSave }) {
  const [themeColors, setThemeColors] = useState({
    primary: '#1976d2',
    secondary: '#9c27b0',
    background: '#ffffff',
    text: '#000000'
  });

  const handleColorChange = (color, type) => {
    setThemeColors(prev => ({
      ...prev,
      [type]: color
    }));
  };

  const handleSave = () => {
    localStorage.setItem('themeColors', JSON.stringify(themeColors));
    onSave(themeColors);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Configuración de Colores</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Color Principal
            </Typography>
            <Box sx={{ mb: 2 }}>
              <HexColorPicker
                color={themeColors.primary}
                onChange={(color) => handleColorChange(color, 'primary')}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Color Secundario
            </Typography>
            <Box sx={{ mb: 2 }}>
              <HexColorPicker
                color={themeColors.secondary}
                onChange={(color) => handleColorChange(color, 'secondary')}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Color de Fondo
            </Typography>
            <Box sx={{ mb: 2 }}>
              <HexColorPicker
                color={themeColors.background}
                onChange={(color) => handleColorChange(color, 'background')}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Color de Texto
            </Typography>
            <Box sx={{ mb: 2 }}>
              <HexColorPicker
                color={themeColors.text}
                onChange={(color) => handleColorChange(color, 'text')}
              />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            Vista Previa
          </Typography>
          <Paper
            sx={{
              p: 2,
              backgroundColor: themeColors.background,
              color: themeColors.text
            }}
          >
            <Typography variant="h6" sx={{ color: themeColors.primary }}>
              Título de Ejemplo
            </Typography>
            <Typography variant="body1">
              Este es un texto de ejemplo para ver cómo se verán los colores en la aplicación.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 2,
                backgroundColor: themeColors.primary
              }}
            >
              Botón Principal
            </Button>
            <Button
              variant="contained"
              sx={{
                mt: 2,
                ml: 2,
                backgroundColor: themeColors.secondary
              }}
            >
              Botón Secundario
            </Button>
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained">
          Guardar Cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ThemeSettings; 